import { useTranslation } from 'react-i18next';
import { Group, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCircleCheck, IconClock } from '@tabler/icons-react';
import DealFactTable from '@/components/app/deals/DealFactTable';
import type { BargainStepsInfo } from '@/types/deals';

interface ClosingStepProps {
  readonly info: BargainStepsInfo;
}

// Шаг «Сделка по факту» (BARGAIN_CLOSING/CLOSED/COMPLETED): статус завершения + таблица по факту
// поставки (реальный объём/качество/итог; зачёт по дню или по среднему) — DealFactTable. Read-only.
export default function ClosingStep({ info }: ClosingStepProps) {
  const { t } = useTranslation();
  const closing = info.processingStep === 'BARGAIN_CLOSING';

  return (
    <Stack gap="lg">
      {closing ? (
        <Group gap="xs" wrap="nowrap">
          <ThemeIcon size={32} radius="xl" variant="light" color="brand">
            <IconClock size={18} />
          </ThemeIcon>
          <Text fz="sm">{t('app.deals.closing.closing')}</Text>
        </Group>
      ) : (
        <Stack gap="xs">
          <Group gap="xs" wrap="nowrap">
            <ThemeIcon size={32} radius="xl" variant="light" color="lime">
              <IconCircleCheck size={18} />
            </ThemeIcon>
            <Text fz="sm" fw={500}>
              {t('app.deals.closing.completed')}
            </Text>
          </Group>
          {info.completedDate ? (
            <Text fz="sm" c="gray.7" pl={40}>
              {t('app.deals.closing.completedOn', { date: info.completedDate })}
            </Text>
          ) : null}
        </Stack>
      )}

      <DealFactTable info={info} />
    </Stack>
  );
}
